import * as React from "react";
import { type ApexChart, type ApexOptions } from "@dia-ui/bundle/dist/collection/components/chart/src/libs/DiaChartMapperAbstract";
import {ForwardedRef} from "react";

/**
 * ChartProps
 */
interface ChartProps {
  type: ApexChart.type;
  width?: ApexChart.width;
  height?: ApexChart.height;
  toolbar?: ApexChart.toolbar;
  stacked?: ApexChart.stacked;
  stackType?: ApexChart.stackType;
  series: ApexOptions.series;
  options?: ApexOptions;
}

/**
 * Chart
 * @param type
 * @param width
 * @param height
 * @param toolbar
 * @param stacked
 * @param stackType
 * @param series
 * @param options
 * @constructor
 */
const Chart: React.FC<ChartProps> = React.forwardRef(({
  type,
  width,
  height,
  toolbar,
  stacked,
  stackType,
  series,
  options
}: ChartProps, ref: ForwardedRef<any>) => {
  return (
    <dia-chart
      ref={ ref }
      // @ts-ignore
      type={ type }
      width={ width }
      height={ height }
      toolbar={ toolbar }
      stacked={ stacked }
      stackType={ stackType }
      series={ JSON.stringify(series) }
      options={ JSON.stringify(options) }
    ></dia-chart>
  );
});

export default Chart;
